import { useModal } from '@/contexts/modal'
import AddIcons from '@/icons/AddIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ICloneProps {
    contractID: number
    subcontractID: number
}
const CreateProcessComponent: React.FC<ICloneProps> = ({
    contractID = 0,
    subcontractID,
}) => {
    const { t } = useTranslation()

    const { open, setModal } = useModal()

    return (
        <>
            <Button
                size="small"
                variant="contained"
                startIcon={<AddIcons />}
                onClick={() =>
                    setModal(
                        'ContractModals/CreateSubcontractProcessModal/index',
                        {
                            contractID: contractID,
                            subcontractID,
                        }
                    )
                }
                disabled={open}
            >
                {t('create-subcontract-process')}
            </Button>
        </>
    )
}

const CreateProcess = (props: ICloneProps) => {
    return <CreateProcessComponent {...props} />
}
export default CreateProcess
